export class ProposalBidDetail {
    id!: string
    proposalBidId!: string
    competitorId!: number
    designFee!: number
    cmFee!: number
    cmMonthlyFee!: number
    contractorOhpFee!: number
    contractorBondsIns!: number
    contractorCoMarkup!: number
    cityBudget!: number
    contractorStartDate?: Date
    contractorNumDays!: number
    contractorNumProjects!: number
    pmNumProjects!: number
    contractorPm!: string
    contractorSuper!: string
    contractorRef1!: string
    contractorRef2!: string
    contractorRef3!: string
}
